import { render, staticRenderFns } from "./FrrRoundBtn.vue?vue&type=template&id=53679c9e&scoped=true&"
import script from "./FrrRoundBtn.vue?vue&type=script&lang=js&"
export * from "./FrrRoundBtn.vue?vue&type=script&lang=js&"
import style0 from "./FrrRoundBtn.sass?vue&type=style&index=0&id=53679c9e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53679c9e",
  null
  
)

export default component.exports